import React from 'react';
import { Link } from 'react-router-dom';
import { eapiClient } from '../../../restClient';
import { Translations } from '../../../utils/';
import './styles.css';

export default class EntitySearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      showOptions: false,
      showCreateEntity: false,
      selectedOptionValue: '',
      selectedOption: ''
    }
  }

  // life cycle hook
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleBackspace)
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang !== undefined ? this.props.lang.currentLang.lang : this.props.lang, this.props.lang.translatedData || this.props.translatedData)
  }

  handleBackspace = (e) => {
    if (e.keyCode === 8) {
      e.preventDefault();
    }
  }

  filterList = (event) => {
    var query = event.target.value;
    let obj = {
      entityName: query
    }
    this.setState({ selectedOptionValue: query });
    if (query.length > 2) {
      this.setState({ showCreateEntity: true });
      let url = '/entities/organisations/search-entity';
      document.addEventListener('keydown', this.handleBackspace);
      eapiClient(url, {
        method: "POST",
        data: JSON.stringify(obj)
      })
        .then(({ data, status }) => {
          document.removeEventListener('keydown', this.handleBackspace)
          if (data.responseStatus.serviceErrorCode !== 404 && Array.isArray(data.responseData) && data.responseData.length > 0) {
            this.setState({ options: data.responseData, showOptions: true });
          } else {
            this.hideOptions();
          }
        });
    } else {
      this.setState({ showCreateEntity: false }, () => {
        this.hideOptions();
      });
    }
  }

  setSelectedOptions = (event, currentEntity) => {
    this.setState({ selectedOption: currentEntity.entityId });
    if (this.props.checkForConflictsStatus !== undefined && !this.props.checkForConflictsStatus) {
      this.props.setSelectedOptions(currentEntity);
      this.resetSearch();
      this.hideOptions();
    } else {
      this.checkForConflicts(currentEntity.entityId, (case_status) => {
        currentEntity.status = case_status.status;
        currentEntity.gdocsTerms = case_status.gdocsTerms;
        this.props.setSelectedOptions(currentEntity);
        this.resetSearch();
        this.hideOptions();
      });
    }
  }

  resetSearch = () => {
    this.setState({ selectedOptionValue: '', options: [], showCreateEntity: false });
  }

  checkForConflicts = (selectedEntityId, cb) => {
    eapiClient('/cases/' + selectedEntityId + '/checkStatus')
      .then(({ data }) => {
        cb(data.responseData);
      });
  }

  showOptions = () => {
    this.setState({ showOptions: true });
  }

  hideOptions = () => {
    this.setState({ showOptions: false });
  }

  onCreateNewEntity = () => {
    this.props.onCreateNewEntity(this.state.selectedOptionValue);
    this.resetSearch();
    this.hideOptions();
  }

  render() {
    const createEntityLink = (
      <div className='createEntity'>
        <span className="icon icon-add addicon"></span>
        <Link id="createnewentity"
          to={{
            pathname: this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-basic-details" ? '' : this.props.createNewEntityLinkRoute,
            state: { newEntityName: this.state.selectedOptionValue }
          }}
          onClick={this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-basic-details" ? this.onCreateNewEntity : ''}>
          {this.translations(this.props.addText)} {`"${this.state.selectedOptionValue}"`}
        </Link>
      </div>
    );

    const options = (
      <List role="option" aria-selected="true" tabIndex="0" items={this.state.options} _setSelectedOptions={(event, entity) => this.setSelectedOptions(event, entity)} />
    );

    return (
      <div className="customersearchcont">
        <div className="filterdata">
          <fieldset className="form-group searchListform">
            <label className="customerlbl">{this.props.AddscustomerTitle}</label>
            <input type="text" tabIndex="0"
              maxLength={this.props.maxLength}
              id="searchText"
              onChange={this.filterList}
              value={this.state.selectedOptionValue}
              readOnly={this.props.disabled}
              className="form-control form-control-lg" />
            <span className="verticalLine"></span>
            <span className="icon icon-search serachicon"></span>
          </fieldset>
        </div>
        <div id="searchId" className="searchList" role="dropdown">
          {this.state.showOptions ? options : ''}
          {this.state.showCreateEntity ? createEntityLink : ''}
        </div>
      </div>
    );
  }
}

const List = (props) => (
  <div className="listContent" id="setList">
    {
      props.items.map((item, index) => (<div className="listdata" key={index}>
        <div className="searchListdata"
          data-category={item.resolveError}
          tabIndex="0"
          onClick={(event) => props._setSelectedOptions(event, item)}>
          {item.entityName + " - " + (item.countryOfFormation !== "" ? item.countryOfFormation.name : 'Not Available')}
        </div>
        <div className="divide"></div>
      </div>))
    }
  </div>
)



// WEBPACK FOOTER //
// ./src/components/common/EntitySearchBox/index.js